<script lang="ts" setup>
import type { GlobalCollectionId } from '#layers/data-model/public';
import { computed } from 'vue';
import { CrudAction, useAuthorization } from '#layers/access/public';
import { useCollection } from '#layers/data-model/public';

const props = defineProps<{
	collectionId: GlobalCollectionId;
}>();

defineEmits<{
	click: [];
}>();

const { can } = useAuthorization();
const { collection } = useCollection(() => props.collectionId);

const canCreate = computed(() =>
	collection.value ? can({ collection: collection.value, action: CrudAction.Create }) : false,
);
</script>

<template>
	<DTooltip
		:text="$t('permissions.no_create_access')"
		:disabled="canCreate"
	>
		<DButton
			:label="$t('common.add_item')"
			:ui="{ label: 'sr-only sm:not-sr-only' }"
			size="sm"
			icon="lucide:plus"
			:disabled="!canCreate"
			@click="$emit('click')"
		/>
	</DTooltip>
</template>
